export default __webpack_public_path__ + "d473d18b48ceb2512227ddd1c307cd8c.jpg";